import ResponsiveDialog from 'components/ResponsiveDialog'
import TextField from 'components/TextField'
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from '@mui/material'
import IndustryField from 'components/SkillsInput/components/IndustryField'
import React, { useEffect } from 'react'
import useSkillSuggestionsForm from './useSkillSuggestionsForm'

export interface ISkillSuggestionsForm {
  isOpened: boolean
  onClose: () => void
  mode: 'profile' | 'job'
  industry?: { id: string, name: string }
}

export const SkillSuggestionsForm = ({ isOpened, onClose, mode, industry }: ISkillSuggestionsForm) => {
  const { submit, setValue, useFormField, reset } = useSkillSuggestionsForm({
    onSuccess: () => {
      reset()
      onClose()
    },
  })
  const industryFormFields = useFormField('industries', 'selection')

  useEffect(() => {
    if (mode === 'profile' && industry) {
      setValue('industries', [{ id: industry.id, name: industry.name }])
    }
  }, [industry?.id])

  return (
    <ResponsiveDialog
      open={isOpened}
      onClose={onClose}
    >
      <form onSubmit={submit}>
        <DialogTitle>
          Add New Skill
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <DialogContentText>
                {mode === 'profile' ? "If you can't find a relevant skill for your profile you can add a custom one" : "If you can't find a relevant skill for your job, you can add a custom one."}
              </DialogContentText>
            </Grid>

            <Grid item xs={12} md={12}>
              <TextField
                {...useFormField('name', 'typing')}
                label="Name"
                fullWidth
              />
            </Grid>

            {mode === 'job' && (
              <Grid item xs={12} md={12}>
                <IndustryField
                  {...industryFormFields}
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose}>
            Cancel
          </Button>

          <Button color="primary" onClick={submit}>
            Submit
          </Button>
        </DialogActions>
      </form>
    </ResponsiveDialog>
  )
}
